import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-truncated-text',
  templateUrl: './truncated-text.component.html',
  styleUrls: ['./truncated-text.component.scss'],
})
export class TruncatedTextComponent implements OnInit {

  @Input() text: string;
  @Input() type: string;
  @Input() limit: number = 40;
  truncating = true;
  public truncatedTextWhenLimit: string = '';

  constructor() { }

  ngOnInit() {
    if (this.limit === 250 && this.text)
      this.truncatedTextWhenLimit = `${this.text.substring(0, this.limit)} `

  }

  expand() {
    this.truncating = !this.truncating;
  }

}
